/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Grid, Typography2 } from '@coursera/cds-core';
import { Pill, color } from '@coursera/coursera-ui';

import _t from 'i18n!nls/reviews';

export type ReviewHighlight = {
  highlightText: string;
  reviewCount: number;
};

export type Props = {
  highlights: Array<ReviewHighlight>;
};

const gridStyle = css`
  && {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export default function ReviewHighlights({ highlights }: Props) {
  return (
    <div className="rc-ReviewHighlights border-bottom">
      <Grid container className="p-y-2" alignItems="center" wrap="wrap" css={gridStyle}>
        <Grid item className="text-secondary">
          {_t('Highlights')}
        </Grid>
        {highlights.map(({ highlightText, reviewCount }) => (
          <Pill key={highlightText} rootClassName="m-a-1s" size="lg" fillColor={color.aliceBlue}>
            <Grid alignItems="center">
              <Grid className="font-sm bold d-inline-block">{highlightText}</Grid>
              {reviewCount > 0 && (
                <Typography2 component="p" className="d-inline-block m-x-1s">
                  <FormattedMessage message={_t('({numReviews} Reviews)')} numReviews={reviewCount} />
                </Typography2>
              )}
            </Grid>
          </Pill>
        ))}
      </Grid>
    </div>
  );
}
